import { Badge } from '@mantine/core';
import type { LeadStatus } from '@/models/leads';

const colors: Record<LeadStatus, string> = {
  'New Lead': 'yellow',
  'Contact Attempt': 'pink',
  'Meeting Scheduled': 'indigo',
  'Meeting Complete': 'violet',
  'Proposal Sent': 'blue',
  '2nd Meeting +': 'dark',
  'Deal Opportunity': 'green',
  Lost: 'red',
  Won: 'teal',
  converted: 'grape',
};

export function StatusBadge({ status }: { status: LeadStatus }) {
  return (
    <Badge color={colors[status] ?? 'gray'} variant="light">
      {status === 'converted' ? 'Converted' : status}
    </Badge>
  );
}
